import { Heading, Text, VStack } from '@chakra-ui/react';
import { ReadingColumn, SiteShell } from '../components/site/SiteChrome';
import { CostsCard } from '../components/site/CostsCard';
import { SITE } from '../content/site';
import { useT } from '../i18n';

// Pricing (M42 D105, M43): free, with the published costs and what
// families have paid.
export function PricingPage() {
  const t = useT();
  return (
    <SiteShell>
      <ReadingColumn>
        <VStack align="stretch" spacing={6}>
          <Heading
            as="h1"
            fontSize={{ base: '36px', md: '48px' }}
            lineHeight={1.05}
          >
            {t('site.pricing.title')}
          </Heading>
          <Text fontSize="18px" lineHeight="27px" color="ink.body">
            {t('site.pricing.intro', { name: SITE.name })}
          </Text>
          <CostsCard />
          <Text color="muted" fontSize="15px">
            {t('site.pricing.razorpay')}
          </Text>
        </VStack>
      </ReadingColumn>
    </SiteShell>
  );
}
